document.addEventListener('DOMContentLoaded', function() {

    //Création de compte
    let email = document.querySelector('input[type=email]');
    if(email) {
        let username = document.querySelector('input#username_field');
        if(username) {
            email.addEventListener('input', function() {
                username.value = this.value;
            });
        }
    }

    let username = document.querySelector('input#name_field');
    let prenom = document.querySelector('input#first_name_field');
    let nom = document.querySelector('input#last_name_field');
    if(username && nom && prenom) {
        [nom, prenom].forEach(function(element) {
            element.addEventListener('input', function() {
                changeInputName(nom, prenom, username);
            });
        });
    }

});

function changeInputName(nom, prenom, username) {

    if(nom.value && prenom.value) {
        username.value = prenom.value + ' ' + nom.value;
    }
}



// WEBPACK FOOTER //
// ./js/app.js